import { Component, forwardRef, Input } from '@angular/core';
import { ConfigGeoRegions } from '../../../config/geo-regions';
import { AbstractValueAccessor } from '../abstract-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export interface GeoRegion
{
    countryCode: string;
    region: string;
}

export const GEO_REGION_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GeoRegionSelectorComponent),
    multi: true,
};

@Component({
    selector: 'lf-geo-region-selector',
    styleUrls: ['./geo-region-selector.scss'],
    templateUrl: './geo-region-selector.component.html',
    providers: [GEO_REGION_INPUT_VALUE_ACCESSOR],
})
export class GeoRegionSelectorComponent extends AbstractValueAccessor<GeoRegion>
{
    @Input() placeholder: string = '';
    @Input() readonly = false;
    @Input() tabindex: number = 0;

    countries: {
        country: string,
        regions: GeoRegion[]
    }[] = ConfigGeoRegions.RegionsByCountry;

    public writeValue(value: GeoRegion) {
        value = this.findRegionOption(value);

        if (value !== this._value) {
            this._value = value;
            this.propagateChange(this._value);
        }
    }

    public findRegionOption(value: GeoRegion) {
        if (!value) {
            return null;
        }

        let targetRegion = null;
        this.countries.forEach((country) => {
            country.regions.forEach((region) => {
                if (region.countryCode === value.countryCode && region.region === value.region) {
                    targetRegion = region;
                }
            });
        });

        return targetRegion;
    }
}
